import styled from "styled-components";
import { borderRadius, fontSizes, shadows, spacing } from "@magicbi/ui-library";
import { popoverMotion } from "../../../design-system/tokens/popoverMotion";
import { rawColors as appColors } from "../../../design-system/tokens/colors";

export const Menu = styled.div`
  /* GAP: design 300px wide; nearest token (18.75rem). */
  width: 18.75rem;
  box-sizing: border-box;
  padding: ${spacing[1.5]};
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius["2xl"]};
  background: ${({ theme }) => theme.colors.background.primary};
  box-shadow: ${shadows.component.modal};
  ${popoverMotion()}
`;

export const Row = styled.button`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  width: 100%;
  height: ${spacing[10]};
  padding: 0 ${spacing[3]};
  border: 0;
  border-radius: ${borderRadius.xl};
  background: transparent;
  text-align: left;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.primary};
  text-decoration: none;
  font-size: ${fontSizes["13"]};

  &:hover,
  &:focus-visible {
    background: ${({ theme }) => theme.colors.primary[50]};
    outline: none;
  }

  &[aria-disabled="true"] {
    color: ${({ theme }) => theme.colors.text.tertiary};
    cursor: not-allowed;
    background: transparent;
  }
`;

export const Icon = styled.span<{ $tone?: "neutral" | "accent" }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: ${spacing[6]};
  height: ${spacing[6]};
  border-radius: ${borderRadius.lg};
  background: ${({ theme, $tone }) => ($tone === "accent" ? appColors.accent.cross.bg : theme.colors.grey[100])};
  color: ${({ theme, $tone }) => ($tone === "accent" ? appColors.accent.cross.text : theme.colors.text.secondary)};

  [aria-disabled="true"] > & {
    background: ${({ theme }) => theme.colors.background.secondary};
    color: ${({ theme }) => theme.colors.text.tertiary};
  }
`;

export const Label = styled.span`
  flex: 1;
  min-width: 0;
`;
